<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import PrintOptions from "@/components/modals/print-options.vue";
import { groupBy } from "lodash";
import OPCRTemplate from "./posted-opcr.vue";
import { required } from "vuelidate/lib/validators";
import PlanningRatingScale from "@/components/modals/planning-rating-scale.vue";
import OpcrLogs from "@/router/views/office/office-widgets/opcr-logs.vue";
import { Carousel, Slide } from "vue-carousel";

export default {
    page: {
    title: "OPCRs",
  },
  components: {
    Layout,
    PageHeader,
    PrintOptions,
    OPCRTemplate,
    PlanningRatingScale,
    OpcrLogs,
    Carousel,
    Slide
  },
  data() {
    return {
      title: "Planning OPCRs",
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: "OPCRs",
          active: true,
        },
      ],
      pmeOPCRs: [],
      pmtOPCRs: [],
      allCampus: [],  
      returnForm: {
        id: 0,
        remarks: "",
      },
      opcrBusy: false,
      pmtType: 'Pending',
      pmeType: 'Pending',
      opcrStatus: "Pending",
      planningType: 'pme',
      reportList: false,
      slideNum: 1,
      groupCampus: "",
    };
  },
  validations: {
    returnForm: { remarks: { required } },
  },
  async created(){
    this.opcrBusy = true;
    await this.getOPCRsByDU(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
    await this.getPMTPendingData(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
    this.opcrBusy = false;
    this.allCampus = this.$store.state.decrypt.campusAccessList();
  },
  methods: {
    async changeCycle(cycle){
      this.opcrBusy = true;
      await this.getOPCRsByDU(cycle, this.$store.state.data.selectedCampus.id);
      await this.getPMTPendingData(cycle, this.$store.state.data.selectedCampus.id);
      this.opcrBusy = false;
    },
    async changeCampus(campusId){
      this.opcrBusy = true;
      await this.getOPCRsByDU(this.$store.state.data.cycle, campusId);
      await this.getPMTPendingData(this.$store.state.data.cycle, campusId);
      this.opcrBusy = false;
    },
    async getPMTPendingData(cycle, campusId){
      await this.$store
        .dispatch("preopcr/GetPendingByFinanceAndPlanning", {
          campusId, cycle
        })
        .then((res) => {
          if(res.data.error){
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.map(item => {
            item.showTargets = false;
            item.targets = [];
            item.loadTarget = false;
            item.showLibs = false;
            item.libs = [];
            item.loadLib = false;
          })
          var grouped = groupBy(res.data, "deliveryUnitId");
          var data = [];
          for (var key in grouped) {
            data.push({
              deliveryUnitId: key,
              deliveryUnit: grouped[key][0].deliveryUnit,
              count: grouped[key].length,
              opcrs: grouped[key],
            });
          }
          this.pmtOPCRs = data;
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
    },
    async getPMTApprovedData(cycle, campusId){
      await this.$store
        .dispatch("preopcr/GetApproveByFinanceAndPlanning", {
          campusId, cycle
        })
        .then((res) => {
          if(res.data.error){
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.map(item => {
            item.showTargets = false;
            item.targets = [];
            item.loadTarget = false;
            item.showLibs = false;
            item.libs = [];
            item.loadLib = false;
          })
          var grouped = groupBy(res.data, "deliveryUnitId");
          var data = [];
          for (var key in grouped) {
            data.push({
              deliveryUnitId: key,
              deliveryUnit: grouped[key][0].deliveryUnit,
              count: grouped[key].length,
              opcrs: grouped[key],
            });
          }
          this.pmtOPCRs = data;
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
    },
    async printPPMPAPI(id) {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/PrePlanning/PPMP/API",
        routeVariables: [id],
      });
      this.$bvModal.show("print-options-modal");
    },
    returnOPCR(opcr, type, planningType){
      this.planningType = planningType;
      this.returnForm = {
        id: opcr.id,
        remarks: "",
        type: type
      }
      this.$bvModal.show("return-modal");
    },
    async returnOPCRSubmit() {
      this.submitted = true;
      this.$v.returnForm.$touch();
      if (this.$v.returnForm.$invalid) {
        return;
      }
      await this.$store
          .dispatch("preopcr/ReturnOPCR", this.returnForm)
          .then((res) => {
              if (res.data.error) {
                  return this.showToast(res.data.errorMessage, "error");
              }
              console.log(this.planningType)
              if(this.planningType == 'pme'){
                this.$refs.pmeOPCR.removeOPCR(this.returnForm.id)
              }else{
                this.$refs.pmtOPCR.removeOPCR(this.returnForm.id)
              }
              this.$bvModal.hide('return-modal');
              this.showToast("Successfully returned", "success");
          })
          .catch((err) => {
            console.log(err);
              this.showToast("Something went wrong!", "error");
          });
    },
    async changeFilter(index){
      this.pmtType = index;
      if(index == 'Pending'){
        this.opcrBusy = true;
        await this.getPMTPendingData(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
        this.opcrBusy = false;
      }else{
        this.opcrBusy = true;
        await this.getPMTApprovedData(this.$store.state.data.cycle, this.$store.state.data.selectedCampus.id);
        this.opcrBusy = false;
      }
    },
    async printOPCR({id, type}) {
      let apiUrl = "api/Report/PrePlanning/OPCR";
      if(type == 2){
        apiUrl = "api/Report/PrePlanning/OPCR/V2";
      }else if(type == 3){
        apiUrl = "api/Report/PrePlanning/OPCR/V3";
      }else if(type == 4){
        apiUrl = "api/Report/PrePlanning/OPCR/V4";
      }
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: [id],
      });
      this.$bvModal.show("print-options-modal");
    },
    async printTPMS(id){
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/My/PPMP/OPCR",
        routeVariables: [id],
      });
      this.$bvModal.show("print-options-modal");
    },
    changeOPCRStatus(status) {
      this.opcrStatus = status;
      this.getOPCRsByDU(
        this.$store.state.data.cycle,
        this.$store.state.data.selectedCampus.id
      );
    },
    async getOPCRsByDU(cycle, campusId) {
      let url = "";
      if (this.opcrStatus == "Pending") {
        url = "GetPostedPlanningOPCR";
      } else {
        url = "GetApprovedPlanningOPCR";
      }
      this.opcrBusy = true;
      await this.$store
        .dispatch(`preopcr/${url}`, {
          campusId,
          cycle,
        })
        .then((res) => {
          this.opcrBusy = false;
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.map((item) => {
            item.showTargets = false;
            item.targets = [];
            item.loadTarget = false;
            item.showLibs = false;
            item.libs = [];
            item.loadLib = false;
          });
          var grouped = groupBy(res.data, "deliveryUnitId");
          var data = [];
          for (var key in grouped) {
            data.push({
              deliveryUnitId: key,
              deliveryUnit: grouped[key][0].deliveryUnit,
              count: grouped[key].length,
              opcrs: grouped[key],
            });
          }
          this.pmeOPCRs = data;
        })
        .catch(() => {
          this.showToast("Something went wrong!", "error");
        });
    },
    getPerformanceRating(row, type) {
      this.$refs.PlanningRatingScale.setMeasurement(row, type);
      this.$bvModal.show("performance-rating-modal");
    },
    viewLogs(opcr){
      this.$bvModal.show('opcr-logs-modal');
      this.$refs.opcrLogs.modalTitle = `${opcr.title} Logs`
      this.$refs.opcrLogs.getData(opcr);
    },
    goBackToSelection() {
        this.slideNum = 1;
        this.$refs.carousel.goToPage(this.$refs.carousel.getPreviousPage());
    },
    renderSelection() {
        this.reportList = true;
        this.slideNum = 1;
        this.$nextTick(() => {
            this.$refs.carousel.goToPage(0);
        });
    },
    goToSelection() {
      this.slideNum = 2;
      this.$refs.carousel.goToPage(this.$refs.carousel.getNextPage());
    },
    printRatedOPCR(type){
      this.reportList = false;
      var apiUrl = "";
      var routeVariables = [];
      if(type == 'all'){
        apiUrl = "api/Report/Planning/Rated/OPCR"
        routeVariables = [this.$store.state.data.cycle];
      }else{
        apiUrl = "api/Report/Planning/Rated/OPCR/Campus"
        routeVariables = [this.$store.state.data.cycle, this.groupCampus];
      }
      this.$refs.printOpt.putOptions({
          apiUrl: apiUrl,
          routeVariables: routeVariables,
      });
      this.$bvModal.show("print-options-modal");
    }
  }
}
</script>
<template>
    <Layout @changeCycle="changeCycle" @changeCampus="changeCampus($event.id)">
      <PageHeader :title="title" :items="items" />
      <b-modal
        id="return-modal"
        title="Return Remarks"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
      >
        <form @submit.prevent="returnOPCRSubmit" class="needs-validation">
            <b-row>
                <b-col>
                    <div class="mb-3">
                        <label for="description">Remarks </label>
                        <textarea
                            id="description"
                            rows="3"
                            v-model="returnForm.remarks"
                            placeholder="Enter Remarks..."
                            class="form-control"
                            :class="{
                                'is-invalid':
                                    submitted &&
                                    $v.returnForm.remarks.$error,
                            }"
                        ></textarea>
                        <div
                            v-if="submitted && $v.returnForm.remarks.$error"
                            class="invalid-feedback"
                        >
                            <span v-if="!$v.returnForm.remarks.required"
                                >This value is required.</span
                            >
                        </div>
                    </div>
                </b-col>
            </b-row>
            <div class="modal-footer">
                <button type="submit" class="btn btn-primary">
                    Return API
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('return-modal')"
                >
                    Close
                </button>
            </div>
        </form>
      </b-modal>
      <div class="position-relative">
        <b-tabs nav-class="nav-tabs-custom" content-class="pt-3 pb-3 text-muted">
          <b-tab>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="bx bx-home"></i>
              </span>
              <span class="d-none d-sm-inline-block"
                >For PME Review</span
              >
            </template>
            <OPCRTemplate
              :campusTemplates="pmeOPCRs"
              @print-ppmp-api="printPPMPAPI"
              @return-opcr="returnOPCR($event, pmeType, 'pme')"
              @change-status="changeOPCRStatus"
              :busy="opcrBusy"
              :withStatusSelection="true"
              @print-opcr="printOPCR"
              @getPerformanceRating="getPerformanceRating($event, pmeType, 'opcr')"
              @viewLogs="viewLogs"
              @print-tpms="printTPMS"
              ref="pmeOPCR"
            />
          </b-tab>
          <b-tab>
            <template v-slot:title>
              <span class="d-inline-block d-sm-none">
                <i class="bx bx-home"></i>
              </span>
              <span class="d-none d-sm-inline-block"
                >For PMT Review</span
              >
            </template>
            <OPCRTemplate 
              :campusTemplates="pmtOPCRs" 
              @print-ppmp-api="printPPMPAPI" 
              :withLib="true" 
              @return-opcr="returnOPCR($event, pmtType, 'pmt')"
              @print-opcr="printOPCR"
              @change-status="changeFilter"
              @viewLogs="viewLogs"
              :withStatusSelection="true"
              :busy="opcrBusy"
              @print-tpms="printTPMS"
              ref="pmtOPCR"
            />
          </b-tab>
        </b-tabs>
        <div class="position-absolute" style="top:0;right:0;">
          <button
            type="button"
            class="btn btn-purple me-1"
            id="select-report"
            @click="renderSelection"
        >
            <i class="bx bx-printer me-1"></i>Reports
        </button>
        <b-popover
            :target="`select-report`"
            triggers="click"
            placement="left"
            :show.sync="reportList"
            custom-class="popover-report"
        >
            <template v-slot:title>
                <div
                    class="
                        d-flex
                        align-items-center
                        justify-content-between
                    "
                >
                    <small>Report List</small>
                    <span
                        class="
                            bx bx-x
                            font-size-14
                            cursor-pointer
                        "
                        @click="reportList = false"
                    ></span>
                </div>
            </template>
            <carousel
                ref="carousel"
                class="
                    events
                    navs-carousel
                    custom-carousel
                "
                id="timeline-carousel"
                :navigation-enabled="false"
                :pagination-enabled="false"
                :perPage="1"
                :autoplay="false"
                :minSwipeDistance="0"
                :mouseDrag="false"
            >
                <slide>
                    <div v-if="slideNum == 1">
                        <div>
                            <a
                                href="javascript:void(0);"
                                @click="printRatedOPCR('all')"
                                class="
                                    font-size-12
                                    text-dark
                                    hoverable-link
                                "
                                >Rated OPCR (All)</a
                            >
                        </div>
                        <hr class="my-1" />
                        <div>
                            <a
                                href="javascript:void(0);"
                                @click="goToSelection"
                                class="
                                    font-size-12
                                    text-dark
                                    hoverable-link
                                "
                                >Rated OPCR (By {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}})</a
                            >
                        </div>
                    </div>
                </slide>
                <slide>
                    <div v-if="slideNum == 2">
                        <a
                            href="javascript:void(0);"
                            class="
                                text-dark
                                d-flex
                                align-items-center
                            "
                            @click="goBackToSelection"
                            ><i
                                class="
                                    bx bx-left-arrow-alt
                                    me-1
                                "
                            ></i
                            >Go back to selection</a
                        >
                        <div>
                            <select
                                class="
                                    form-select
                                    mt-2
                                    mb-2
                                "
                                v-model="groupCampus"
                            >
                                <option value="">
                                    Select {{GLOBAL_FROM_SCHOOL ? 'Campus' : 'Main Office'}}
                                </option>
                                <option
                                    v-for="x in allCampus"
                                    :key="x.Id"
                                    :value="x.Id"
                                >
                                    {{ x.CampusName }}
                                </option>
                            </select>
                            <button
                                type="button"
                                @click="printRatedOPCR('campus')"
                                class="
                                    btn
                                    btn-purple
                                    btn-sm
                                    btn-block
                                    mt-2
                                "
                                v-if="groupCampus > 0"
                            >
                                <i
                                    class="
                                        bx bx-printer
                                        me-1
                                    "
                                ></i>
                                Print Report
                            </button>
                        </div>
                    </div>
                </slide>
            </carousel>
        </b-popover>
        </div>
      </div>
      <print-options ref="printOpt"></print-options>
      <PlanningRatingScale ref="PlanningRatingScale"></PlanningRatingScale>
      <opcr-logs ref="opcrLogs"></opcr-logs>
    </Layout>
</template>